<template>
  <button
    :class="[
      'dropdown-trigger',
      { active: isActive, 'has-value': filterHasValue },
    ]"
    :inert="isDisabled"
    data-test-id="filter-dropdown-trigger"
    @click="handleClick"
  >
    <x-body-text weight="medium">{{ label }}</x-body-text>
    <x-icon icon="arrow-dropdown" width="24px" class="dropdown-indicator" />
  </button>
</template>

<script setup lang="ts">
import xIcon from '@/components/shared/x-icon/index.vue'
import xBodyText from '@/components/shared/x-body-text/index.vue'

interface FilterDropdownTriggerProps {
  isActive: boolean
  label: string
  filterHasValue?: boolean
  isDisabled?: boolean
}

const props = withDefaults(defineProps<FilterDropdownTriggerProps>(), {
  filterHasValue: false,
  isDisabled: false,
})

const emit = defineEmits<{
  (e: 'toggle', value: boolean): void
}>()

const handleClick = () => {
  emit('toggle', !props.isActive)
}
</script>

<style lang="scss" scoped>
.dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ys-spacing-100);
  width: 100%;
  padding: var(--ys-spacing-100) var(--ys-spacing-100) var(--ys-spacing-100)
    var(--ys-spacing-250);
  border-radius: 100px;
  box-shadow:
    0px 1px 6px 0px rgba(0, 0, 0, 0.12),
    0px 2px 5px 0px rgba(0, 0, 0, 0.14);
  color: var(--ys-color-surface-reverse);
  background-color: var(--ys-color-text-reverse);

  &.active,
  &.has-value {
    color: var(--ys-color-text-reverse);
    background-color: var(--ys-color-surface-reverse);
    .dropdown-indicator {
      color: var(--ys-color-text-reverse);
    }
  }

  &[inert] {
    opacity: 0.5;
    pointer-events: none;
  }

  .dropdown-indicator {
    transform-origin: center;
    transition: transform 0.25s ease-in-out;
    color: var(--ys-color-surface-reverse);
  }
  &.active {
    .dropdown-indicator {
      transform: rotate(180deg);
    }
  }
}
</style>
